<template>
  <div class="warp">
    <el-form :key="keyInvoice" label-width="auto">
      <el-row :gutter="20">
        <el-descriptions :colon="false" :column="3" direction="vertical">
          <!--签收签名-->
          <el-descriptions-item :label="$t('GlobalSetObj.signedPhoto')">
            <div
              v-if="tableInfomation.signedNamePhoto"
              class="QuestionMark"
              @click="imageSee(tableInfomation.signedNamePhoto)"
            >
              {{ $t('home.clickSee') }}
            </div>
            <div v-else>{{ '--' }}</div>
          </el-descriptions-item>
          <!--签收照片-->
          <el-descriptions-item :label="$t('GlobalSetObj.signedNamePhoto')" :span="2">
            <div
              v-if="tableInfomation.signedPhoto"
              class="QuestionMark"
              @click="imageSee(tableInfomation.signedPhoto)"
            >
              {{ $t('home.clickSee') }}
            </div>
            <div v-else>{{ '--' }}</div>
          </el-descriptions-item>
          <!--签收人类型-->
          <el-descriptions-item :label="$t('GlobalSetObj.TypeRecipient')">
            <div>{{ tableInfomation.signTypeName }}</div>
          </el-descriptions-item>
          <!--签收人关系-->
          <el-descriptions-item :label="$t('GlobalSetObj.signRelation')">
            <div>{{ tableInfomation.notMyselfTypeStr || '--' }}</div>
          </el-descriptions-item>
          <!--签收人人名-->
          <el-descriptions-item :label="$t('GlobalSetObj.SignerName')">
            <div>{{ tableInfomation.deliverySigner || '--' }}</div>
          </el-descriptions-item>
          <!--签收人DOC-->
          <el-descriptions-item :label="$t('GlobalSetObj.RecipientDOC')">
            <div>{{ tableInfomation.receiverDocumentNumber || '--' }}</div>
          </el-descriptions-item>
          <!--签收时间-->
          <el-descriptions-item :label="$t('GlobalSetObj.SigningTime')" :span="3">
            <div>{{ tableInfomation.deliveredTime || '--' }}</div>
          </el-descriptions-item>
        </el-descriptions>
      </el-row>
    </el-form>
    <imageSeeDialog ref="imageSeeDialogRef" />
  </div>
</template>

<script>
import imageSeeDialog from '@/components/imageSeeDialog/index.vue';

export default {
  name: 'SigneInfo',
  components: {
    imageSeeDialog
  },
  props: {
    tableInfomation: {
      type: Object,
      required: true,
      default: () => {}
    },
    queryTrackParam: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      keyInvoice: new Date().getTime()
    };
  },
  methods: {
    // 点击查看 图片
    imageSee(row) {
      console.log(row, 'row');
      if (row) {
        const imageArr = row.split(',');
        if (imageArr && imageArr.length > 0) {
          this.imageList = imageArr.map((item) => {
            return item + '?imageMogr2/thumbnail/2000x2000>/quality/80/format/jpg/ignore-error/1';
          });
          this.$refs.imageSeeDialogRef.showImageFun(this.imageList);
        }
      }
    }
  }
};
</script>

<style scoped>
.warp /deep/ .el-descriptions-item__label {
  font-size: 13px;
  color: #909399;
}

.warp /deep/ .el-descriptions-item__cell {
  /*height: 35px !important;*/
  padding-bottom: 2px !important;
}

.QuestionMark {
  cursor: pointer;
  color: #00A551;
}

.el-descriptions-item__cell div {
  font-weight: bold;
  font-size: 15px;
}
</style>
